import React from "react";
import { Card, CardContent, Box, Skeleton } from "@mui/material";

const TemplateSkeletonCard = () => {
  return (
    <Card sx={{ width: "100%", height: "100%", minWidth: 0 }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          p: 2.5,
          "&:last-child": { pb: 2.5 },
        }}
      >
        <Box sx={{ height: "2.8em", fontSize: "1.1rem" }}>
          <Skeleton variant="text" width="90%" height="1.4em" />
          <Skeleton variant="text" width="55%" height="1.4em" />
        </Box>
        <Box sx={{ height: "3em", fontSize: "0.875rem" }}>
          <Skeleton variant="text" width="100%" height="1.5em" />
          <Skeleton variant="text" width="80%" height="1.5em" />
        </Box>
        <Skeleton
          variant="rounded"
          width="60%"
          height={28}
          sx={{ borderRadius: 999 }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            mt: "auto",
            pt: 2,
            borderTop: 1,
            borderColor: "divider",
            minHeight: 20,
          }}
        >
          <Skeleton variant="rounded" width={20} height={20} />
          <Skeleton variant="rounded" width={20} height={20} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TemplateSkeletonCard;
